import { InputNumber } from "antd";
import React, { useEffect, useState } from "react";
import { $t } from "~/i18n.js";

export const TacometerInput = ({ motor_format, value, readOnly, onChange }) => {
  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [decimalHours, setDecimalHours] = useState(0);

  // Convert minutes to hours and minutes or decimal hours when value changes
  useEffect(() => {
    if (value !== undefined && value !== null) {
      const totalMinutes = parseInt(value) || 0;
      const h = Math.floor(totalMinutes / 60);
      const m = totalMinutes % 60;
      setHours(h);
      setMinutes(m);
      setDecimalHours(parseFloat((totalMinutes / 60).toFixed(2)));
    }
  }, [value]);

  // Handle decimal hours input
  const handleDecimalChange = (newValue) => {
    if (newValue !== null && newValue !== undefined) {
      setDecimalHours(newValue);
      const totalMinutes = Math.round(newValue * 60);
      onChange && onChange(totalMinutes);
    }
  };

  // Handle hours input for HH:MM format
  const handleHoursChange = (newHours) => {
    if (newHours !== null && newHours !== undefined) {
      setHours(newHours);
      const totalMinutes = (newHours * 60) + minutes;
      onChange && onChange(totalMinutes);
    }
  };

  // Handle minutes input for HH:MM format
  const handleMinutesChange = (newMinutes) => {
    if (newMinutes !== null && newMinutes !== undefined) {
      // Cycle minutes: if >= 60, reset to 0; if < 0, set to 59
      let validMinutes = newMinutes;
      if (newMinutes >= 60) {
        validMinutes = 0;
      } else if (newMinutes < 0) {
        validMinutes = 59;
      }
      setMinutes(validMinutes);
      const totalMinutes = (hours * 60) + validMinutes;
      onChange && onChange(totalMinutes);
    }
  };

  if (motor_format === "decimal") {
    return (
      <InputNumber
        value={decimalHours}
        onChange={handleDecimalChange}
        readOnly={readOnly}
        disabled={readOnly}
        variant={readOnly ? "borderless" : undefined}
        min={0}
        step={0.1}
        precision={2}
        style={{ width: 120 }}
        placeholder="0.00"
        addonAfter={$t("uren")}
      />
    );
  }

  // HH:MM format
  return (
    <div className="row" style={{ gap: 6, alignItems: "center" }}>
      <InputNumber
        value={hours}
        onChange={handleHoursChange}
        readOnly={readOnly}
        variant={readOnly ? "borderless" : undefined}
        disabled={readOnly}
        min={0}
        style={{ width: 100 }}
        placeholder="0"
        addonAfter={$t('uur')}
      />
      <span>{" "}</span>
      <InputNumber
        value={minutes}
        onChange={handleMinutesChange}
        readOnly={readOnly}
        variant={readOnly ? "borderless" : undefined}
        disabled={readOnly}
        style={{ width: 100 }}
        placeholder="00"
        addonAfter={$t('min')}
      />
    </div>
  );
};
